import { BCMSRecord, useGlobalController, Workflow } from "@bcm-dev/bcms-vite";
import LoginFastBalancesPage from "components/pages/LoginFastBalancesPage";
import Classes, { Account } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <LoginFastBalancesPage /> ];

/**
 * @function LoginFastBalancesWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the MABI23 "Login Fast Balances" page. 
 * This is an ABI22 workflow only used inside of the MABI23 wrapper demo.
 */
export default function LoginFastBalancesWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);
    const accounts = Account.initAll();
    // Return the default workflow state
    return {
        accounts
    };
};